var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DotsMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "20px",
    viewBox: "0 0 6 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7D99C1A4-E937-418E-B06C-00F57B3D7EF4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-Center--New-Message",
    transform: "translate(-1344.000000, -88.000000)",
    fill: "#A2A2A2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1346.86482,103.55308 C1348.09359,103.55308 1349.0897,104.549197 1349.0897,105.777969 C1349.0897,107.006742 1348.09359,108.002858 1346.86482,108.002858 C1345.63604,108.002858 1344.63993,107.006742 1344.63993,105.777969 C1344.63993,104.549197 1345.63604,103.55308 1346.86482,103.55308 Z M1346.86482,95.7779693 C1348.09359,95.7779693 1349.0897,96.774086 1349.0897,98.0028582 C1349.0897,99.2316304 1348.09359,100.227747 1346.86482,100.227747 C1345.63604,100.227747 1344.63993,99.2316304 1344.63993,98.0028582 C1344.63993,96.774086 1345.63604,95.7779693 1346.86482,95.7779693 Z M1346.86482,88.0028582 C1348.09359,88.0028582 1349.0897,88.9989749 1349.0897,90.2277471 C1349.0897,91.4565193 1348.09359,92.452636 1346.86482,92.452636 C1345.63604,92.452636 1344.63993,91.4565193 1344.63993,90.2277471 C1344.63993,88.9989749 1345.63604,88.0028582 1346.86482,88.0028582 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DotsMenu);
export default __webpack_public_path__ + "static/media/3-dots-menu.b06675fe963399f53c50b9d5ffe09637.svg";
export { ForwardRef as ReactComponent };